/**
 * Golf FS IRONS Reducers
 */
import {
    WEDGEPLAY_ACTION,
    ALL_WEDGEPLAY,
    ADD_WEDGEPLAY,
    FETCH_WEDGEPLAY,
    EDIT_WEDGEPLAY,
    DELETE_WEDGEPLAY
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    tqwedgeplaylist:[],
    particulartqwedgeplay:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case WEDGEPLAY_ACTION:
            return { ...state, loading: true };       

        case ALL_WEDGEPLAY:
            return { ...state, loading: false, tqwedgeplaylist: action.payload };     
            
        case ADD_WEDGEPLAY:
            return { ...state, loading: false };     
         
        case FETCH_WEDGEPLAY:
            return { ...state, loading: false, particulartqwedgeplay: action.payload };  
            
        case EDIT_WEDGEPLAY:
            return { ...state, loading: false }; 
            
        case DELETE_WEDGEPLAY:
            return { ...state, loading: false };     
        
        default: return { ...state };

     }
 }